import ContainerCrypto from '../../../Component/Dashboard/Crypto/Crypto'

const Crypto = () => {
  return (
    <div className='page-body'>
      <ContainerCrypto />
    </div>
  )
}

export default Crypto